import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import supplementsCollection from 'modules/payroll_bundle/store/collections/supplements'
import type Supplement from 'modules/payroll_bundle/store/models/Supplement'

interface ISupplementBulkImport {
  [key: string]: any
}

class SupplementBulkImport extends Model<ISupplementBulkImport> {
  constructor(attr: ISupplementBulkImport = {}) {
    super(attr)
    makeObservable(this, {
      supplements: computed,
    })
  }

  static urlRoot() {
    return '/payroll/supplement_bulk_imports'
  }

  get supplements(): Supplement[] {
    return supplementsCollection.filter({ supplement_bulk_import_id: this.attributes.id })
  }
}

export default SupplementBulkImport
